var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{ref:"map",attrs:{"center":_vm.center,"zoom":13}},[_c('gmap-marker',{attrs:{"icon":_vm.locationIcon,"position":_vm.center}}),_vm._v(" "),_vm._l((_vm.stores),function(store){return _c('store-marker',{key:`store-${store.ID}`,attrs:{"store":store}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }